module.exports = __webpack_public_path__ + "static/SpaceMono-Regular-81050990fec6b693a43b860681531ec5.woff";